import React from 'react';
import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip,
} from 'recharts';

function ratingColor(rating) {
  if (!rating) return '#9ca3af';
  const r = rating.toLowerCase();
  if (r.includes('extreme greed')) return '#16a34a';
  if (r.includes('greed')) return '#65a30d';
  if (r.includes('neutral')) return '#a3a3a3';
  if (r.includes('fear') && !r.includes('extreme')) return '#ea580c';
  if (r.includes('extreme fear')) return '#dc2626';
  return '#9ca3af';
}

function FearGreedCard({ data }) {
  if (!data || !data.current) {
    return (
      <div className="bg-gray-900 border border-gray-700 rounded-lg p-4 h-full">
        <h3 className="text-sm font-semibold text-gray-300 mb-2">Fear & Greed</h3>
        <p className="text-gray-500 text-sm">Unavailable</p>
      </div>
    );
  }

  const { current, previous_close, one_week_ago, one_month_ago, one_year_ago, history } = data;
  const color = ratingColor(current.rating);
  const chartData = (history || []).map((h) => ({ date: h.date, score: h.score }));

  return (
    <div className="bg-gray-900 border border-gray-700 rounded-lg p-4 h-full flex flex-col">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-baseline gap-3 flex-wrap">
          <h3 className="text-sm font-semibold text-gray-300">Fear & Greed</h3>
          <span className="text-4xl font-bold" style={{ color }}>
            {Math.round(current.score)}
          </span>
          <span className="text-sm uppercase tracking-wide" style={{ color }}>
            {current.rating || '—'}
          </span>
        </div>
        <span className="text-xs text-gray-500">CNN</span>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 flex-1">
        <div className="sm:w-44 flex-shrink-0">
          <div className="grid grid-cols-2 gap-x-3 gap-y-1 text-xs">
            <div className="text-gray-400">Prev close</div>
            <div className="text-right text-gray-200">{previous_close ?? '—'}</div>
            <div className="text-gray-400">1 wk ago</div>
            <div className="text-right text-gray-200">{one_week_ago ?? '—'}</div>
            <div className="text-gray-400">1 mo ago</div>
            <div className="text-right text-gray-200">{one_month_ago ?? '—'}</div>
            <div className="text-gray-400">1 yr ago</div>
            <div className="text-right text-gray-200">{one_year_ago ?? '—'}</div>
          </div>
        </div>
        <div className="flex-1 min-h-[140px]">
          <ResponsiveContainer width="100%" height="100%" minHeight={140}>
            <AreaChart data={chartData}>
              <defs>
                <linearGradient id="fgGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={color} stopOpacity={0.5} />
                  <stop offset="100%" stopColor={color} stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="date" hide />
              <YAxis domain={[0, 100]} hide />
              <Tooltip
                contentStyle={{ background: '#111827', border: '1px solid #374151', fontSize: 12 }}
                labelStyle={{ color: '#9ca3af' }}
                formatter={(v) => [v, 'Score']}
              />
              <Area type="monotone" dataKey="score" stroke={color} fill="url(#fgGrad)" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="text-[10px] text-gray-500 mt-2">~1yr history · 0 = extreme fear, 100 = extreme greed</div>
    </div>
  );
}

export default FearGreedCard;
